import { useNavigate } from "react-router-dom";


export default function ResearchObjectives({researchObject,methadology}:any) {
  const formatKey = (key: string) =>
  key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <div className="flex items-center h-full flex-col">
      <h1 className="relative inline-block text-white text-center font-extrabold 
              max-w-4xl text-2xl lg:text-4xl font-nunito mb-2 
              bg-gradient-to-r from-[#92D050] to-[#8CC54F] 
              px-6 py-2
              before:content-[''] before:absolute before:left-0 before:top-1/2 
              before:-translate-y-1/2 before:-translate-x-full
              before:border-y-[16px] before:border-r-[16px] before:border-y-transparent 
              before:border-r-[#92D050]

              after:content-[''] after:absolute after:right-0 after:top-1/2 
              after:-translate-y-1/2 after:translate-x-full
              after:border-y-[16px] after:border-l-[16px] after:border-y-transparent 
              after:border-l-[#8CC54F]">Research Objectives & Methodology</h1>

      
      <div className="flex gap-3">
        <div className="flex flex-col">
          <h4 className="text-black font-semibold mt-4 text-xl max-w-4xl text-center">Research Objectives</h4>
          <ul className="border border-[#8CC54F] p-2 max-w-xl rounded-lg flex flex-col list-disc gap-2 mt-3 list-inside flex-auto">
            {researchObject.map((item:any)=>(
                <li key={item.index}>{item}</li>
            ))}
          </ul>
        </div>
        <div className="flex flex-col">
          <h4 className="text-black font-semibold mt-4 text-xl max-w-4xl text-center">Methodology</h4>
         <ul className="border border-[#8CC54F] p-2 max-w-xl rounded-lg flex flex-col gap-2 mt-3 list-disc list-inside">
            {Object.entries(methadology).map(([key, value]) => (
                <li key={key}>
                  <strong>{formatKey(key)}:</strong>{" "}
                  {Array.isArray(value) ? value.join(", ") : String(value)}
                </li>
              ))}

          </ul>
        </div>
      </div>
    </div>
  );
}
